import React, { Component, Fragment } from 'react';

import './styles.css';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {String} heading
 * @prop {String} subheading
 *
 * @augments {Component<Props>}
 */
export default class SectionHeading extends Component {
	render () {
		const { heading, subheading } = this.props;
		return (
			<Fragment>
				<div className='SectionSubHeading'>{subheading}</div>
				<h2 className='SectionHeading'>{heading}</h2>
			</Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/molecules/SectionHeading/SectionHeading.js